module.exports = __webpack_public_path__ + "img/3.f842f00.png";